<template lang="pug">
.resident-detail-modal-for-cooperation-system
  b-modal(v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    .register-body(v-if="_item")
      FormLabel(v-model="_item.kanaName" keyName="利用者名（ふりがな）")
      FormLabel(v-model="_item.name" keyName="利用者名")
      FormLabel(v-model="_item.kanaName" keyName="利用者名（ふりがな）")
      FormLabel(v-model="_item.gender" keyName="性別")
      FormLabel(v-model="_birthday" keyName="生年月日")
      FormLabel(v-model="_item.tel" keyName="電話番号")
      FormLabel(v-model="_item.room" keyName="部屋")
      FormLabel(v-model="_item.residentGroupName" keyName="利用者グループ")
      FormLabel(v-model="_item.insuredNumber" keyName="保険者番号")
      FormLabel(v-model="_item.careInsuranceInsuredNumber" keyName="介護保険被保険者番号")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ResidentsForCooperationSystemTableItem } from "./ResidentsForCooperationSystemTable.vue";

import FormLabel from "@/pc/components/forms/FormLabel.vue";

@Component({
  components: {
    FormLabel
  }
})
export default class ResidentDetailModalForCooperationSystem extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  @Prop()
  item!: ResidentsForCooperationSystemTableItem;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _item(): ResidentsForCooperationSystemTableItem | null {
    return this.item ? this.item : null;
  }

  get _birthday(): string {
    if (this.item && this.item.birthday) {
      return this.$dateUtil.convertNumberToString(this.item.birthday, "yyyy年mm月dd日");
    } else {
      return "";
    }
  }
}
</script>
